import { ReactNode } from 'react';

import { CurrencyInput } from 'components/CurrencyInput';
import { CurrencyCode } from 'utils/constants/currency';

import { Field } from './Field/Field';

type Props = {
  name: string;
  label?: ReactNode;
  description?: string;
  errorMessage?: string;
  mapError?: (arg0: string) => ReactNode;
  placeholder?: string;
  min?: number;
  max?: number;
  step?: string;
  currencyCode?: CurrencyCode;
  type?: string;
};

export function CurrencyInputField({
  name,
  label,
  description,
  mapError,
  placeholder,
  min,
  max,
  currencyCode,
  type,
  ...props
}: Props) {
  return (
    <Field
      inputProps={props}
      name={name}
      label={label}
      description={description}
      mapError={mapError}
      customCompare={() => false}
      renderInput={({ value, id, qaId, hasError, updateValue }) => (
        <CurrencyInput
          id={id}
          name={name}
          value={value}
          hasError={hasError}
          data-qa-id={qaId}
          onChange={(e) => {
            const newValue = e.target.value;
            updateValue(newValue === '' ? undefined : newValue);
          }}
          placeholder={placeholder}
          min={min}
          max={max}
          currencyCode={currencyCode}
          type={type}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...props}
        />
      )}
    />
  );
}
